import { createRouter, createWebHashHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../page/index.vue')
  },
  {
    path: '/registered',
    name: 'registered',
    component: () => import(/* webpackChunkName: "home" */ '../page/registered.vue')
  },
  {
    path: '/success',
    name: 'success',
    component: () => import(/* webpackChunkName: "home" */ '../page/success.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
